import Vue from "vue";
import money from 'v-money'
import mask from "vue-the-mask";

Vue.use(mask);
Vue.use(money, {
  precision: 2,
  decimal: ',',
  thousands: '.',
  prefix: 'R$ ',
});
